module.exports = __webpack_public_path__ + "static/media/logoanim-light.37459292.gif";